<template>
	<div
		id="config-modal"
		class="modal fade"
		tabindex="1"
		aria-labelledby="config-modal"
	>
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content p-4">
				<div class="modal-header position-relative">
					<h4 class="text-center pt-3 mb-0">
						TEMPO DE ENVIO DA MENSAGEM
					</h4>
					<div class="position-absolute ps-r--1 ps-t--3">
						<button
							id="close-modal"
							class="btn btn-light btn-sm m-2"
							@click="Close()"
						>
							<i class="fal fa-times"></i>
						</button>
					</div>
				</div>
				<div class="modal-body py-4">
					<div
						class="w-full h-full d-flex flex-column items-center justify-center gap-5"
					>
						<form class="w-full">
							<div
								class="w-full form-group flex items-center gap-3"
							>
								<input
									type="text"
									id="interval_number"
									name="interval_number"
									class="form-control"
									v-model="form.interval_number"
									placeholder="EX: 1"
									tabindex="2"
								/>
								<select
									id="interval_type"
									name="interval_type"
									class="form-control"
									v-model="form.interval_type"
									tabindex="3"
								>
									<option
										value="hour"
										:selected="
											form.interval_type === 'hour'
										"
									>
										Hora(s)
									</option>
									<option
										value="day"
										:selected="form.interval_type === 'day'"
									>
										Dia(s)
									</option>
									<option
										value="week"
										:selected="
											form.interval_type === 'week'
										"
									>
										Semana(s)
									</option>
									<option
										value="month"
										:selected="
											form.interval_type === 'month'
										"
									>
										Mes(es)
									</option>
									<option
										value="year"
										:selected="
											form.interval_type === 'year'
										"
									>
										Ano(s)
									</option>
								</select>
								<span class="flex-1">antes do atendimento</span>
							</div>
						</form>
					</div>
				</div>
				<div class="modal-footer px-0 pb-0 flex justify-end">
					<button
						class="save"
						tabindex="4"
						@click="Save"
					>
						Salvar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ConfigModal',
		props: {
			config: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				form: {
					id: null,
					interval_number: null,
					interval_type: 'day',
				},
			}
		},
		watch: {
			config: {
				handler(config) {
					if (config.id) {
						this.form.id = config.id
						this.form.interval_number = config.interval_number
						this.form.interval_type = config.interval_type
					}
				},
				immediate: true,
				deep: true,
			},
		},
		methods: {
			Open() {
				window.jQuery('#config-modal').modal('show')
			},
			Close() {
				window.jQuery('#config-modal').modal('hide')
				window.jQuery('body').removeClass('modal-open')

				window.jQuery('.modal-backdrop').remove()

				this.$emit('close')
			},
			Save() {
				this.$emit('save', this.form)

				this.Close()
			},
		},
		async mounted() {
			this.Open()

			window.jQuery('#config-modal').on('hidden.bs.modal', () => {
				window.jQuery('body').removeClass('modal-open')

				window.jQuery('.modal-backdrop').remove()

				this.$emit('close')
			})
		},
	}
</script>

<style lang="scss" scoped>
	#config-modal {
		.modal-dialog {
			max-width: 30vw;

			.modal-body {
				form {
					input,
					select {
						width: 20%;
					}
				}
			}

			.modal-footer {
				button.save {
					padding: 0.6rem 1rem;
					color: var(--white);
					font-weight: bold;
					font-size: 1.2rem;
					outline: none;
					background-color: var(--successBackgroundColor);
					border: 1px solid var(--successBackgroundColor);
					border-radius: 1rem;

					transition: background 0.1s ease-in-out;

					&:hover {
						background-color: var(--successHoverBackgroundColor);
						border-color: var(--successHoverBackgroundColor);
					}
				}
			}
		}
	}
</style>
